import styled from 'styled-components';

import { InterwillInfoPanelDesktop } from '@/_pages/interwill/components/InfoPanel/InfoPanelDesktop';
import { InterwillInfoPanelMobile } from '@/_pages/interwill/components/InfoPanel/InfoPanelMobile';
import { useIwBreakPoints } from '@/_pages/interwill/hooks/useIwBreakPoints';

export const InfoPanel = () => {
  const { isMobile } = useIwBreakPoints();

  return (
    <Container>
      {isMobile ? <InterwillInfoPanelMobile preopened /> : <InterwillInfoPanelDesktop />}
    </Container>
  );
};

const Container = styled.div`
  height: calc(100vh - 100px);
  pointer-events: none;
  & > div {
    height: 100%;
  }
`;
